module.exports = __webpack_public_path__ + "static/img/success_logo.38d16f03.png";